import { useGetBrIefById } from "@entities/brief/lib/hooks/useGetBriefById";
import { useBriefStore } from "@pages/layout/BriefLayout/lib/useLayoutStore";
import { IAssignedPOC } from "@shared/lib/types/briefInfluencerV2";
import { Button } from "@shared/ui/Button";
import { Flex, Select } from "antd";
import { useState } from "react";

interface AssignPricingModalProps {
  briefInfluencerId: string[];
  assignedTo?: IAssignedPOC["assignedTo"];
  onConfirm: (briefInfluencerId: string[], assignedToUserId: string) => void;
  confirmLoading?: boolean;
  onCancel?: () => void;
}

export function AssignPricingModal({
  briefInfluencerId,
  assignedTo,
  onConfirm,
  confirmLoading,
  onCancel,
}: AssignPricingModalProps) {
  const [selectedAssignedTo, setSelectedAssignedTo] = useState<string>(
    assignedTo?._id || ""
  );

  const { briefId } = useBriefStore();

  const { brief } = useGetBrIefById(briefId);
  const assignOptions = brief?.pricing?.allocatedTo?.map((item) => ({
    label: `${item.user.firstName} ${item.user.lastName}`,
    value: item.userId,
  }));

  return (
    <Flex vertical gap={24} style={{ marginTop: 24 }}>
      <Select
        options={assignOptions}
        value={selectedAssignedTo}
        onChange={(value) => {
          setSelectedAssignedTo(value);
        }}
      />
      <Flex justify="end" gap={16}>
        <Button variant="outlined" onClick={onCancel}>
          Cancel
        </Button>
        <Button
          type="primary"
          disabled={!selectedAssignedTo}
          onClick={() => {
            onConfirm(briefInfluencerId, selectedAssignedTo);
          }}
          loading={confirmLoading}
        >
          Assign
        </Button>
      </Flex>
    </Flex>
  );
}
